import { render, staticRenderFns } from "./CollapsibleCard.vue?vue&type=template&id=469c396d&"
import script from "./CollapsibleCard.vue?vue&type=script&lang=js&"
export * from "./CollapsibleCard.vue?vue&type=script&lang=js&"
import style0 from "./CollapsibleCard.vue?vue&type=style&index=0&id=469c396d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports